import React, { Component } from 'react';

import { List, Datagrid, FilterForm } from 'components/list';
import { TextField } from 'components/field';
import { EditButton } from 'components/button';

import * as urls from './urls';
import * as utils from './utils';


function ReminderConfigFilter(props) {
  return (
    <FilterForm 
      name='reminder_config_filter'
      {...props}
    />
  );
}

const CustomTextField = (props) => {
  const { record } = props;

  record.drop_last_support_day = '-';
  if (
    record
    && record.dropping_version_last_support_day
  ) {
    record.drop_last_support_day = utils.convertTimeToDate(record.dropping_version_last_support_day);
  }

  record.latest_version_number = '-';
  if (
    record
    && record.latest_version_info
    && record.latest_version_info.version_number
  ) {
    record.latest_version_number = record.latest_version_info.version_number;
  }

  return (
    <TextField 
      {...props}
    />
  )
};

export class ReminderConfigList extends Component {
  render() {
    return (
      <List 
        filters={<ReminderConfigFilter/>}
        {...this.props}
        autoLoadData={true}
      >
        <Datagrid 
          bodyOptions={{stripedRows: true, showRowHover: true}}
        >
          <TextField source="app_type" label="App" choices={utils.APP_TYPE_LIST} />
          <TextField source="client_type" label="Platform" choices={utils.CLIENT_TYPE_LIST} />
          <CustomTextField source="latest_version_number" label="Latest Version" />
          <CustomTextField source="min_version_number" label="Min. Required Version" />
          <CustomTextField source="dropping_version_number" label="Drop Version" />
          <CustomTextField source="drop_last_support_day" label="Drop Version Last Supported Date" />
          <EditButton linkTo={urls.reminderConfigUpdateDetailFrontendPath} label="View/Edit New Update"/>
          <EditButton linkTo={urls.reminderConfigDropDetailFrontendPath} label="View/Edit Drop Version"/>
        </Datagrid>
      </List>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/advancedFunction/ReminderConfigList.js